import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

const DeleteConfirm = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
          maxWidth: 400,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 3 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: 'error.light',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            opacity: 0.15,
          }}
        >
          <Warning color="error" sx={{ fontSize: 32 }} />
        </Box>
        <DialogTitle id="delete-dialog-title" sx={{ textAlign: 'center', fontWeight: 700, pb: 1 }}>
          {title || 'Delete Confirmation'}
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          <DialogContentText id="delete-dialog-description">
            {message || 'Are you sure you want to delete this item? This action cannot be undone.'}
          </DialogContentText>
        </DialogContent>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', px: 3, pb: 3, gap: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          fullWidth
          sx={{ py: 1, borderRadius: 2 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          fullWidth
          autoFocus
          sx={{ py: 1, borderRadius: 2 }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirm;
